import React from 'react';

const Badge = ({ children, type = 'default' }) => {
  const styles = {
    hot: { background: 'var(--color-hot-bg)', color: 'var(--color-hot-text)' },
    warm: { background: 'var(--color-warm-bg)', color: 'var(--color-warm-text)' },
    cold: { background: 'var(--color-cold-bg)', color: 'var(--color-cold-text)' },
    dead: { background: 'var(--color-dead-bg)', color: 'var(--color-dead-text)' },
    won: { background: 'var(--color-stage-won-bg)', color: 'var(--color-stage-won-text)', border: '1px solid var(--color-stage-won-border)' },
    lost: { background: 'var(--color-stage-lost-bg)', color: 'var(--color-stage-lost-text)', border: '1px solid var(--color-stage-lost-border)' },
    default: { background: 'var(--color-background-secondary)', color: 'var(--color-text-secondary)', border: '1px solid var(--color-border-tertiary)' }
  };

  const currentStyle = styles[type.toLowerCase()] || styles.default;

  return (
    <span style={{
      display: 'inline-block',
      padding: '4px 10px',
      borderRadius: 'var(--border-radius-md)',
      fontSize: '12px',
      fontWeight: '600',
      ...currentStyle
    }}>
      {children}
    </span>
  );
};

export default Badge;
